(function(root){
  'use strict';
  function state({available,busy,name,demo}){
    if(busy)return {disabled:true,label:'Ajout en cours…'};
    if(!available)return {disabled:true,label:'Indisponible'};
    if(name!==null&&!name.trim())return {disabled:false,label:'Personnaliser'};
    return {disabled:false,label:demo?'Ajouter · test':'Ajouter au panier'};
  }
  function buy({form,button,field,reduced=false}){
    if(button.disabled||button.getAttribute('aria-disabled')==='true'||button.classList.contains('loading'))return 'blocked';
    if(field){
      field.value=field.value.trim();
      if(!field.value){field.scrollIntoView({block:'center',behavior:reduced?'instant':'smooth'});field.focus({preventScroll:true});return 'needs-name';}
      if(!field.checkValidity()){field.reportValidity();return 'invalid';}
    }
    if(!form.reportValidity())return 'invalid';
    form.requestSubmit(button);return 'submitted';
  }
  function attach({form,button,price,title,demo=false,watchRoot,hasVariant=()=>true}){
    const doc=form.ownerDocument,win=doc.defaultView,field=form.querySelector('[data-mpc-name],#child-name');
    const bar=doc.createElement('aside');bar.className='mpc-mobile-buy';bar.setAttribute('aria-label','Votre sélection et ajout au panier');
    bar.innerHTML='<div class="mpc-mobile-buy-summary"><small></small><strong aria-live="polite"></strong><span></span></div><button class="mpc-primary" type="button"></button>';
    bar.querySelector('small').textContent=title;
    const amount=bar.querySelector('strong'),nameLabel=bar.querySelector('.mpc-mobile-buy-summary span'),action=bar.querySelector('button');
    doc.body.append(bar);
    const mq=win.matchMedia('(max-width: 749px)'),reduced=win.matchMedia('(prefers-reduced-motion: reduce)');
    let disposed=false;
    const write=(element,text)=>{if(element.textContent!==text)element.textContent=text;};
    function sync(){
      if(disposed)return;
      const busy=button.getAttribute('aria-disabled')==='true'||button.classList.contains('loading');
      const available=!button.disabled&&hasVariant();
      const current=state({available,busy,name:field?field.value:null,demo});
      action.disabled=current.disabled;write(action,current.label);write(amount,available?price():'—');
      write(nameLabel,field?.value.trim()?'Pour '+field.value.trim():(field?'Prénom à renseigner':'Votre sélection'));
      const keyboard=win.visualViewport&&doc.activeElement===field&&win.innerHeight-win.visualViewport.height>130;
      const modal=doc.querySelector('dialog[open],cart-drawer.active');
      bar.hidden=!mq.matches||Boolean(keyboard)||Boolean(modal);
      doc.body.classList.toggle('mpc-mobile-product',mq.matches);
    }
    action.addEventListener('click',()=>{if(!hasVariant())return;buy({form,button,field,reduced:reduced.matches});sync();});
    const onBlur=()=>win.setTimeout(sync,150);
    form.addEventListener('input',sync);form.addEventListener('change',sync);form.addEventListener('focusin',sync);form.addEventListener('focusout',onBlur);
    const observer=new win.MutationObserver(sync);observer.observe(watchRoot||form,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class','value']});
    const modalObserver=new win.MutationObserver(sync);doc.querySelectorAll('dialog,cart-drawer').forEach(el=>modalObserver.observe(el,{attributes:true,attributeFilter:['open','class']}));
    mq.addEventListener('change',sync);win.visualViewport?.addEventListener('resize',sync);sync();
    return {sync,destroy(){disposed=true;observer.disconnect();modalObserver.disconnect();form.removeEventListener('input',sync);form.removeEventListener('change',sync);form.removeEventListener('focusin',sync);form.removeEventListener('focusout',onBlur);mq.removeEventListener('change',sync);win.visualViewport?.removeEventListener('resize',sync);bar.remove();doc.body.classList.remove('mpc-mobile-product');}};
  }
  const api={state,buy,attach};if(typeof module!=='undefined'&&module.exports)module.exports=api;else root.MpcMobileBuy=api;
})(globalThis);
